 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import { useFragment, usePreloadedQuery} from 'react-relay'




import TaskFooterIntegrateMenuList from './TaskFooterIntegrateMenuList'
import TaskFooterIntegrateMenuSignup from './TaskFooterIntegrateMenuSignup'

import CreateTaskIntegrationMutation from '../mutations/CreateTaskIntegrationMutation'
import useAtmosphere from '../hooks/useAtmosphere'
import {makePlaceholder, useIsIntegrated} from '../hooks/useIsIntegrated'








const query = graphql`
  query TaskFooterIntegrateMenuQuery($teamId: ID!, $userId: ID!) {
    viewer {
      id
      assigneeTeamMember: teamMember(userId: $userId, teamId: $teamId) {
        preferredName
        prevUsedRepoIntegrations(first: 1) {
          items {
            id
          }
        }
        integrations {
          ...useIsIntegrated_integrations
          ...TaskFooterIntegrateMenuSignup_TeamMemberIntegrations
        }
      }
      viewerTeamMember: teamMember(userId: null, teamId: $teamId) {
        integrations {
          ...useIsIntegrated_integrations
          ...TaskFooterIntegrateMenuSignup_TeamMemberIntegrations
        }
      }
    }
  }
`

const TaskFooterIntegrateMenu = (props) => {
  const {menuProps, mutationProps, task: taskRef, queryRef} = props
  const data = usePreloadedQuery(query, queryRef)
  const {viewer} = data
  const task = useFragment(
    graphql`
      fragment TaskFooterIntegrateMenu_task on Task {
        id
        teamId
        userId
      }
    `,
    taskRef
  )
  const atmosphere = useAtmosphere()

  const {id: viewerId, viewerTeamMember, assigneeTeamMember} = viewer
  const isViewerIntegrated = useIsIntegrated(_optionalChain([viewerTeamMember, 'optionalAccess', _ => _.integrations]))
  const isAssigneeIntegrated = useIsIntegrated(_optionalChain([assigneeTeamMember, 'optionalAccess', _2 => _2.integrations]))
  if (!assigneeTeamMember || !viewerTeamMember) return null
  const {integrations: viewerIntegrations} = viewerTeamMember
  const {preferredName: assigneeName, prevUsedRepoIntegrations} = assigneeTeamMember
  const {teamId, userId, id: taskId} = task
  const isViewerAssignee = viewerId === userId
  const showAssigneeIntegrations = !!(
    isAssigneeIntegrated && _optionalChain([prevUsedRepoIntegrations, 'access', _3 => _3.items, 'optionalAccess', _4 => _4.length])
  )
  const {submitMutation, onError, onCompleted} = mutationProps

  const handlePushToIntegration = (
    integrationRepoId,
    integrationProviderService
  ) => {
    const variables = {
      integrationRepoId,
      taskId: taskId,
      integrationProviderService: integrationProviderService
    }
    submitMutation()
    CreateTaskIntegrationMutation(atmosphere, variables, {onError, onCompleted})
  }

  if (isViewerIntegrated) {
    const placeholder = makePlaceholder(isViewerIntegrated)
    const label = 'Push with your credentials'
    return (
      React.createElement(TaskFooterIntegrateMenuList, {
        menuProps: menuProps,
        placeholder: placeholder,
        teamId: task.teamId,
        onPushToIntegration: handlePushToIntegration,
        label: label,}
      )
    )
  }

  if (showAssigneeIntegrations) {
    const placeholder = makePlaceholder(isAssigneeIntegrated)
    const label = isViewerAssignee ? undefined : `Push as ${assigneeName}`
    return (
      React.createElement(TaskFooterIntegrateMenuList, {
        menuProps: menuProps,
        placeholder: placeholder,
        teamId: task.teamId,
        onPushToIntegration: handlePushToIntegration,
        label: label,}
      )
    )
  }
  const label = isViewerAssignee
    ? "You don't have any integrations for this team yet."
    : `Neither you nor ${assigneeName} has any integrations for this team.`

  return (
    React.createElement(TaskFooterIntegrateMenuSignup, {
      menuProps: menuProps,
      mutationProps: mutationProps,
      teamId: teamId,
      label: label,
      integrationsRef: viewerIntegrations,}
    )
  )
}

export default TaskFooterIntegrateMenu
